import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
`

export const Right = styled.div`
  align-items: center;
  display: flex;
  height: calc(100vh - 100px);
  justify-content: center;
  width: 50%;

  @media(max-width: 576px){
    display: none;
  }
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  justify-content: center;
  width: 50%;

  @media(max-width: 576px){
    width: 100%;
  }
`

export const Title = styled.h2`
  color: #7bafdf;
`

export const Subtitle = styled.p`
  color: #959595;
  line-height: 16px;
`

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  max-width: 350px;
  row-gap: 16px;
  width: 100%;

  @media(max-width: 576px){
    max-width: 100%;
  }
`
